const LOGO_URL = "https://customer-assets-m6fa6gv7.emergentagent.net/job_womens-shoes-beta/artifacts/104hqz21_Tarishq%20Luxury%20Fashion%20Logo.png";

export default function FootwearLoader({ compact = false }) {
  return (
    <div className={`flex flex-col items-center justify-center ${compact ? "py-8" : "py-16"}`} data-testid="footwear-loader" role="status" aria-label="Loading">
      <div className="relative w-28 h-28">
        <div className="absolute inset-0 rounded-full border border-[#EAEAEA]" />
        <div className="absolute inset-0 rounded-full border-t-2 border-[#C59B27] tq-logo-ring" />
        <div className="absolute inset-2 rounded-full bg-white overflow-hidden flex items-center justify-center shadow-[0_8px_30px_-10px_rgba(18,18,18,0.25)]">
          <img src={LOGO_URL} alt="TARISHQ FASHION" className="w-full h-full object-cover scale-110" loading="eager" />
        </div>
      </div>
      <p className="mt-5 text-[10px] uppercase tracking-[0.5em] text-[#C59B27] tq-loader-text">TARISHQ</p>
      <style>{`
        @keyframes tq-ring-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        .tq-logo-ring { animation: tq-ring-spin 1.4s cubic-bezier(0.6, 0.15, 0.4, 0.85) infinite; }
        @keyframes tq-pulse-text { 0%, 100% { opacity: 0.4; } 50% { opacity: 1; } }
        .tq-loader-text { animation: tq-pulse-text 2s ease-in-out infinite; }
        @media (prefers-reduced-motion: reduce) { .tq-logo-ring, .tq-loader-text { animation: none; } }
      `}</style>
    </div>
  );
}
